import script from "./NavegationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavegationComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavegationComponent.vue?vue&type=style&index=0&id=3c3c9625&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3c9625"]])

export default __exports__